goog.provide('el8.appshared.letterFeedRenderer');

goog.require('el8.service.tooltip');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.util.feed');

/**
 * This function needs to run in the chart feed, chart req act, and practice home req act
 * to make the collapsible sections within letters work across all of those sections
 */
el8.appshared.letterFeedRenderer = (function() {

    return {
        render: function($elt, item, reqActSection) {
            if (!item) { return; }
             // this stuff is unnecessary for unsigned letters
            if (item.is('Letter') && !item.getSignDate()) { return; }
             // stripping collapse for passport-emr letter receipts, for simplicity
            if (item.is('LetterReceipt') && el8Globals.PASSPORT_EMR) { return; }
            var $mainTrigger = $('.letter-toggle-collapse-trigger', $elt);
            var $statusElt = $('.letter-toggle-collapse-status', $elt);

            var $bodyText = $('.letter-body', $elt);
            var isUnreadLetterNotification = $elt.hasClass('unread-letter-notification-item');

            // this is the comments section
            var $secondaryCollapsibleSection = $('.letter-responses-section', $elt);

            // this is the letter body preview
            var $letterBodyPreview = $('.letter-body-preview', $elt);

            // this is the notifications section
            var $secondaryCollapsibleUnreadNotificationSection = $('.letter-unread-notifications-section', $elt);
            var $signSection = $('.feed-summary-sign-section', $elt);

            // this is the fax error long message
            var $faxErrorLongMessageTrigger = $('.fax-error-long-message-collapse-trigger', $elt);
            var $faxErrorLongMessageStatus = $('.fax-error-long-message-collapse-status', $elt);

            // Setup collapsible letter body
            el8.uiwidget.collapsible({
                container: $('.letter-collapsible-section', $elt),
                triggerElt: $mainTrigger,
                statusElt: $statusElt,
                statusTextCollapse: ' ', // prevent default left arrow icon
                statusTextExpand: 'Collapse',
                expandFn: function() {
                    $bodyText.removeClass('el8SingleLineText').addClass('el8Preserve');
                    $secondaryCollapsibleSection.show();
                    $letterBodyPreview.hide();
                    $secondaryCollapsibleUnreadNotificationSection.show();
                    $signSection.show();
                },
                collapseFn: function() {
                    $bodyText.addClass('el8SingleLineText').removeClass('el8Preserve');
                    $secondaryCollapsibleSection.hide();
                    $letterBodyPreview.show();
                    $secondaryCollapsibleUnreadNotificationSection.hide();
                    $signSection.hide();
                },
                // collapse letters in the chart feed and letters with comments or has unread alerts
                isCollapsed: isUnreadLetterNotification || !reqActSection || item.getComments().length
            });

            // Setup collapsible fax long error message
            el8.uiwidget.collapsible({
                container: $('.fax-error-collapsible-section', $elt),
                triggerElt: $faxErrorLongMessageTrigger,
                statusElt: $faxErrorLongMessageStatus,
                statusTextCollapse: ' ',
                statusTextExpand: ' ',
                expandFn: function() {
                    $bodyText.removeClass('el8SingleLineText').addClass('el8Preserve');
                    $faxErrorLongMessageStatus.removeClass('el8LeftArrowIcon').addClass('el8DownArrowIcon');
                },
                collapseFn: function() {
                    $bodyText.addClass('el8SingleLineText').removeClass('el8Preserve');
                    $faxErrorLongMessageStatus.removeClass('el8DownArrowIcon').addClass('el8LeftArrowIcon');
                },
                // collapse fax long error in the chart feed
                isCollapsed: true
            });

            // but letters in reqAct should still have their comment section visible
            if (reqActSection) {
                $secondaryCollapsibleSection.show();
            }

            var commentText = el8.template.ptdata.letters.commentQtip({ count: item.getComments().length });
            el8.service.tooltip.create({
                anchor: $('.comments-icon', $elt),
                text: commentText
            });

            // if there's an in-progress comment open the comment form
            if (item.getInProgressComment()) {
                el8.shared.commentReplyForm.show({
                    container: $elt,
                    docId: item.getId(),
                    sendCallback: function() {
                        // this only for provider passport, seems save to keep in
                        el8.marketing.providerPassportLeadGen.init({});
                    },
                    inProgressText: item.getInProgressComment(),
                    noFirstFocus: false // focusing this is a little jarring
                });
            }
        },

        reset: function($elt, item) {
            var $commentsIcon = $('.comments-icon', $elt);
            el8.service.tooltip.destroy($commentsIcon);

            // save an in-progress comment to the model
            var replyBody = $('.comment-reply-body', $elt);
            var replyText = replyBody.val();
            if (replyText) {
                item.setInProgressComment(replyText);
            }
        }

    };

})();
